import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'channel-select',
  templateUrl: './channel-select.component.html',
})
export class ChannelSelectComponent {
  @Input() selectChannelSource;
  @Input() userId;
  @Output() channelSourceEvent = new EventEmitter<string>();
  selectedChannel: string = sessionStorage.getItem('selectedChannel');
  resetContract: boolean = false;

  constructor(
    protected readonly modal: NgbModal,
    private readonly sharedService: SharedService
  ) {}

  selectChannel(data): void {
    this.selectedChannel = data;
    this.resetContract = sessionStorage.getItem('selectedChannel') !== data;
  }

  submit(): void {
    if (this.resetContract) {
      sessionStorage.removeItem('contractFromCartApi');
      sessionStorage.removeItem('contractFromCartApiName');
    }

    this.sharedService.postPriceChannel(
      localStorage.getItem('user_login_id'),
      this.selectedChannel
    );
    sessionStorage.setItem('selectedChannel', this.selectedChannel);
    setTimeout(() => {
      if (this.selectChannelSource && this.selectChannelSource === 'account') {
        this.channelSourceEvent.emit(this.selectChannelSource);
      } else {
        window.location.reload();
      }
    }, 500);
  }
}
